import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=f18b1d34&scoped=true"
import script from "./Shares.vue?vue&type=script&lang=js"
export * from "./Shares.vue?vue&type=script&lang=js"
import style0 from "./Shares.vue?vue&type=style&index=0&id=f18b1d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18b1d34",
  null
  
)

export default component.exports